/**
 * 工具结果 ID 生成器工厂。
 *
 * @param prefix - ID 前缀，用于区分不同工具类型
 * @returns 生成器函数，每次调用返回形如 `prefix-N-timestamp` 的唯一字符串
 */
export function createIdGenerator(prefix: string) {
  let counter = 0
  return (): string => {
    counter++
    return `${prefix}-${counter}-${Date.now()}`
  }
}
